module.exports = __webpack_public_path__ + "img/card.2305c91f.png";